(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["naqshdar-best-seller-slider"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-nbs]').forEach(function(section){
  var slides = section.querySelectorAll('.nbs__slide');
  var dots = section.querySelectorAll('.nbs__dots button');
  var speed = Number(section.dataset.speed || 3500);
  var index = 0;
  if (slides.length < 2) return;

  function show(next){
    slides[index].classList.remove('is-active');
    dots[index].classList.remove('is-active');
    index = next;
    slides[index].classList.add('is-active');
    dots[index].classList.add('is-active');
  }

  dots.forEach(function(dot, dotIndex){
    dot.addEventListener('click', function(){ show(dotIndex); });
  });

  setInterval(function(){
    show((index + 1) % slides.length);
  }, speed);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["naqshdar-featured-products"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  var prev = event.target.closest('[data-nfp-prev]');
  var next = event.target.closest('[data-nfp-next]');
  var id = prev ? prev.getAttribute('data-nfp-prev') : next ? next.getAttribute('data-nfp-next') : null;
  if (!id) return;
  var rail = document.getElementById('nfp-products-' + id);
  if (!rail) return;
  var amount = rail.clientWidth * 0.85;
  rail.scrollBy({ left: next ? amount : -amount, behavior: 'smooth' });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["naqshdar-tilted-showcase"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-nqtm]').forEach(function(section) {
  var rail = section.querySelector('.nqtm__rail');
  if (!rail) return;

  var interval = Number(section.dataset.interval || 100);
  var step = Number(section.dataset.step || 2);
  var paused = false;

  section.addEventListener('mouseenter', function() {
    paused = true;
  });

  section.addEventListener('mouseleave', function() {
    paused = false;
  });

  setInterval(function() {
    if (paused) return;
    var halfway = rail.scrollWidth / 2;
    if (halfway > 0 && rail.scrollLeft >= halfway) {
      rail.scrollLeft = rail.scrollLeft - halfway;
    }
    rail.scrollLeft = rail.scrollLeft + step;
  }, interval);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["naqshdar-video-reels"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  var card = event.target.closest('.nsv__card');
  var close = event.target.closest('.nsv__close');
  var modal = document.querySelector('.nsv__modal');
  if (!modal) return;

  if (close) {
    modal.close();
    modal.querySelector('.nsv__frame').innerHTML = '';
    return;
  }

  if (!card) return;

  var frame = modal.querySelector('.nsv__frame');
  var preview = card.querySelector('video');
  var url = card.getAttribute('data-video-url');

  frame.innerHTML = '';

  if (preview) {
    var fullVideo = preview.cloneNode(true);
    fullVideo.controls = true;
    fullVideo.muted = false;
    fullVideo.autoplay = true;
    frame.appendChild(fullVideo);
    modal.showModal();
    return;
  }

  if (!url) return;

  var embed = url;

  if (url.indexOf('youtube.com/watch') > -1) {
    var id = new URL(url).searchParams.get('v');
    embed = 'https://www.youtube.com/embed/' + id + '?autoplay=1';
  }

  if (url.indexOf('youtu.be/') > -1) {
    embed = 'https://www.youtube.com/embed/' + url.split('youtu.be/')[1].split('?')[0] + '?autoplay=1';
  }

  if (url.indexOf('facebook.com') > -1) {
    embed = 'https://www.facebook.com/plugins/video.php?href=' + encodeURIComponent(url) + '&show_text=false&autoplay=true';
  }

  if (url.indexOf('instagram.com') > -1 && url.indexOf('/embed') === -1) {
    embed = url.replace(/\/$/, '') + '/embed';
  }

  frame.innerHTML = '<iframe src="' + embed + '" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen loading="lazy"></iframe>';
  modal.showModal();
});

  } catch(e) { console.error(e); }
})();
})();
